// Backend returns a leaf type for updateUser; no sub-selection allowed.
export const UPDATE_USER = /* GraphQL */ `
  mutation UpdateUserMutation($input: UpdateUserInput!) {
    updateUser(input: $input)
  }
`;
